namespace $.$$ {
	const $shm_hitalama_map_page_contextmenu_settings_started = new Set< string >

	const $shm_hitalama_map_page_contextmenu_search_aliases: Record< string, readonly string[] > = {
		text: [ 'текст', 'надпись', 'txt' ],
		tsx: [ 'тсх', 'jsx', 'react', 'компонент' ],
		code_js: [ 'javascript', 'js', 'джаваскрипт', 'код', 'скрипт' ],
		code_html: [ 'html', 'хтмл', 'разметка', 'iframe' ],
		code_css: [ 'css', 'цсс', 'стили', 'style' ],
		code_sql: [ 'sql', 'скл', 'запрос', 'база' ],
		text_md: [ 'markdown', 'md', 'маркдаун', 'текст' ],
		input: [ 'input', 'инпут', 'поле', 'поле ввода', 'ввод' ],
		iframe: [ 'iframe', 'айфрейм', 'фрейм', 'страница', 'html' ],
		range: [ 'range', 'рейндж', 'слайдер', 'ползунок' ],
		date: [ 'date', 'дата', 'календарь' ],
		select: [ 'select', 'селект', 'выбор', 'выпадающее меню', 'dropdown', 'дропдаун', 'список' ],
		button: [ 'button', 'баттон', 'кнопка' ],
		echarts: [ 'echarts', 'chart', 'чарт', 'график', 'диаграмма' ],
		tabulator: [ 'tabulator', 'табулятор', 'таблица', 'grid', 'грид' ],
		ai_request: [ 'ai', 'ии', 'нейросеть', 'запрос', 'промпт' ],
		opencode_session: [ 'opencode', 'open code', 'чат', 'agent', 'агент', 'session', 'сессия' ],
		form: [ 'form', 'форма', 'сбор', 'ба' ],
		deckgl_example: [ 'deck', 'deckgl', 'deck.gl', 'карта', 'map', 'пример' ],
		notebook: [ 'notebook', 'ноутбук', 'группа', 'контейнер' ],
		notebook2: [ 'notebook2', 'ноутбук', 'группа', 'контейнер' ],
		layout_vert: [ 'layout', 'лейаут', 'контейнер', 'вертикальный', 'колонка' ],
		layout_hor: [ 'layout', 'лейаут', 'контейнер', 'горизонтальный', 'строка' ],
		secrets: [ 'secret', 'secrets', 'секрет', 'секреты', 'ключ' ],
		customizer: [ 'customizer', 'кастомайзер', 'редактор', 'виджеты' ],
		form_custom: [ 'form', 'форма', 'таблица', 'json', 'редактор формы' ],
		entity_editor: [ 'entity', 'сущность', 'таблица', 'редактор сущности', 'форма сущностей' ],
		entity: [ 'entity', 'сущность', 'схема', 'модель данных', 'поля сущности' ],
		surreal_table: [ 'surrealdb', 'surreal', 'сюрреал', 'база', 'таблица' ],
		tg_ext: [ 'telegram', 'телеграм', 'tg', 'тг', 'расширение' ],
		viewport_frame: [ 'viewport', 'frame', 'вьюпорт', 'фрейм', 'кадр', 'слайд' ],
		tokens: [ 'token', 'tokens', 'токен', 'токены', 'ключ' ],
		posts: [ 'posts', 'посты', 'лента', 'feed' ],
	}

	export class $shm_hitalama_map_page_contextmenu extends $.$shm_hitalama_map_page_contextmenu {

		item_select_id( id: string ) {
			return `item:${ id }`
		}

		custom_select_id( ref: $giper_baza_link ) {
			return `custom:${ ref.str }`
		}

		map() {
			return this.Map_page().map()
		}

		query( next?: string ) {
			if( next !== undefined && next !== super.query() ) this.selected_id( '' )
			return super.query( next )
		}

		contextmenu_real_pos(): readonly [ number, number ] {
			return this.Map_page().contextmenu_real_pos() as readonly [ number, number ]
		}

		contextmenu_showed( next?: boolean ): boolean {
			const showed = this.Map_page().contextmenu_showed( next )
			if( next === false ) {
				this.query( '' )
				this.selected_id( '' )
				this.applications_expanded( false )
			}
			return showed
		}

		minimal_height() {
			return Math.min( 440, this.Search().minimal_height() + this.List().minimal_height() )
		}

		@ $mol_action
		widget_add( type: string, event?: Event | null ) {
			if( !event ) return null
			const command = `widget_add:${ type }`
			const operation = $shm_hitalama_map_event_claim( event, command )
			if( !operation ) return null
			const pos = this.add_pos()
			this.contextmenu_showed( false )
			$mol_wire_async( ()=> this.widget_add_command( type, pos, operation ) )().catch( error => {
				if( !$mol_promise_like( error ) ) $mol_fail_log( error )
			} )
			return null
		}

		widget_add_command( type: string, pos: readonly number[], operation: string ) {
			const widget = this.presets().create( type, pos, operation )
			new $mol_after_frame(()=> {
				$mol_wire_async( this ).widget_created( widget ).catch( error => {
					if( !$mol_promise_like( error ) ) $mol_fail_log( error )
				} )
			})
			return widget
		}

		@ $mol_action
		widget_created( widget: $shm_hitalama_map_widget ) {
			const id = widget.link().str
			if(
				$shm_hitalama_map_widget_def_has_settings( widget.type() )
				&& !$shm_hitalama_map_page_contextmenu_settings_started.has( id )
			) {
				$shm_hitalama_map_page_contextmenu_settings_started.add( id )
				$mol_wire_async( this ).widget_settings_enable( widget ).catch( error => {
					if( !$mol_promise_like( error ) ) $mol_fail_log( error )
				} )
			}
			this.Map_page().Widget( widget.link() ).Sub().selected( true )
		}

		@ $mol_action
		widget_settings_enable( widget: $shm_hitalama_map_widget ) {
			return this.map().widget_add_batch( `settings:${ widget.link().str }`, ()=> (
				widget.settings_widget_enabled( true )
			) )
		}

		customs() {
			return this.custom_refs_filtered().map( ref => this.Custom_add( ref ) )
		}

		custom_add_title( ref: $giper_baza_link ) {
			const custom = $giper_baza_glob.Pawn( ref, $shm_hitalama_map_widget_entity_custom )
			return super.custom_add_title(0).replace( '{title}', custom.title() )
		}

		custom_add( ref: $giper_baza_link, event?: Event | null ) {
			if( !event ) return null
			return $shm_hitalama_map_event_once( event, `custom_add:${ ref.str }`, ()=> {
				const custom = $giper_baza_glob.Pawn( ref, $shm_hitalama_map_widget_entity_custom )

				const widget = this.map().widget_add( 'custom', this.add_pos() )
				widget?.Type_custom(null)?.remote( custom )

				this.contextmenu_showed( false )
				return widget
			} )
		}

		items() {
			return this.item_ids_filtered( this.item_ids() ).map( id => this.Item_add( id ) )
		}

		items_top() {
			return this.item_ids_filtered( this.item_ids_top() ).map( id => this.Item_add( id ) )
		}

		items_top2() {
			return this.item_ids_filtered( this.item_ids_top2() ).map( id => this.Item_add( id ) )
		}

		rows() {
			const items_top = this.items_top()
			const items_top2 = this.items_top2()
			return [
				... ( items_top.length ? [ this.Top() ] : [] ),
				... ( items_top2.length ? [ this.Top2() ] : [] ),
				... this.items(),
				this.Customs(),
				this.Applications(),
				this.Application_list(),
			]
		}

		application_rows() {
			return this.application_ids_visible().map( id => this.Application_add( id ) )
		}

		@ $mol_mem
		application_definitions() {
			return this.$.$shm_hitalama_components_catalog.current()?.definitions() ?? []
		}

		applications_opened( next?: boolean ) {
			if( next !== undefined ) this.applications_expanded( next )
			return Boolean( this.query().trim() ) || this.applications_expanded()
		}

		application_ids_visible() {
			if( !this.query().trim() && !this.applications_expanded() ) return []
			const definitions = this.application_definitions()
			return definitions
				.filter( item => item.widget_type() )
				.filter( item => this.query_matches( `${ item.display_name() } ${ item.class_name() } Приложения` ) )
				.toSorted( ( a, b )=> a.display_name().localeCompare( b.display_name(), 'ru' ) )
				.map( item => item.class_name() )
		}

		application_definition( id: string ) {
			const definition = this.application_definitions().find( item => item.class_name() === id )
			if( !definition ) throw new Error( 'Приложение больше не доступно. Откройте меню снова.' )
			return definition
		}

		application_title( id: string ) {
			return this.application_definition( id ).display_name()
		}

		application_selected( id: string ) {
			return this.selected_select_id() === `application:${ id }`
		}

		@ $mol_mem_key
		application_initialize( id: string ) {
			const definition = this.application_definition( id )
			return ( widget: $shm_hitalama_map_widget )=> widget.Type_custom( null )!.remote( definition )
		}

		@ $mol_action
		application_add( id: string, event?: Event ) {
			if( !event ) return null
			const operation = $shm_hitalama_map_event_claim( event, `application_add:${ id }` )
			if( !operation ) return null
			const pos = this.add_pos()
			this.contextmenu_showed( false )
			$mol_wire_async( this ).application_add_command( id, pos, operation ).catch( ( error: unknown ) => {
				if( !$mol_promise_like( error ) ) $mol_fail_log( error )
			} )
			return null
		}

		@ $mol_action
		application_add_command( id: string, pos: readonly number[], operation: string ) {
			if( !this.map().can_change() ) return null
			const definition = this.application_definition( id )
			// Resolve before publishing, and reuse the same creation batch on suspension.
			const title = definition.display_name()
			const initialize = this.application_initialize( id )
			const widget = this.map().widget_add_batch( operation, ()=> {
				return this.map().widget_add( 'application', pos, 600, 400, title, '', undefined, `application:${ id }`, initialize )!
			} )
			new this.$.$mol_after_frame( ()=> $mol_wire_async( ()=> this.widget_created( widget ) )() )
			return widget
		}

		@ $mol_mem
		custom_refs_filtered() {
			const visible = this.map().Customs()?.remote_list().filter( custom => {
				return custom.Visible_in_contextmenu()?.val()
			} ) ?? []

			return visible
				.filter( custom => this.query_matches( custom.title() ) )
				.map( custom => custom.link() )
		}

		item_ids_filtered( ids: readonly string[] ) {
			return ids.filter( id => this.query_matches( this.item_search_text( id ) ) )
		}

		item_search_text( id: string ) {
			return [
				id,
				this.item_title( id ),
				... ( $shm_hitalama_map_page_contextmenu_search_aliases[ id ] ?? [] ),
			].join( ' ' )
		}

		query_matches( text: string ) {
			const query = this.query().trim().toLocaleLowerCase()
			if( !query ) return true
			return text.toLocaleLowerCase().includes( query )
		}

		select_ids() {
			return [
				... this.item_ids_filtered( this.item_ids_top() ).map( id => this.item_select_id( id ) ),
				... this.item_ids_filtered( this.item_ids_top2() ).map( id => this.item_select_id( id ) ),
				... this.item_ids_filtered( this.item_ids() ).map( id => this.item_select_id( id ) ),
				... this.custom_refs_filtered().map( ref => this.custom_select_id( ref ) ),
				... this.application_ids_visible().map( id => `application:${ id }` ),
			]
		}

		selected_select_id() {
			// Built-in presets must not wait for the map's legacy component lands.
			// Resolve the full dynamic list only when navigation actually needs it.
			const builtins = [ ...this.item_ids_top(), ...this.item_ids_top2(), ...this.item_ids() ]
				.filter( id => this.query_matches( this.item_search_text( id ) ) )
				.map( id => this.item_select_id( id ) )
			const selected = this.selected_id()
			if( selected && !selected.startsWith( 'item:' ) ) return selected
			return builtins.includes( selected ) ? selected : builtins[0] ?? ''
		}

		item_selected( id: string ) {
			return this.selected_select_id() === this.item_select_id( id )
		}

		custom_selected( ref: $giper_baza_link ) {
			return this.selected_select_id() === this.custom_select_id( ref )
		}

		select_shift( shift: number ) {
			const ids = this.select_ids()
			if( !ids.length ) return

			const selected = this.selected_select_id()
			const current = ids.indexOf( selected )
			const next = current < 0 ? shift > 0 ? 0 : ids.length - 1 : ( current + shift + ids.length ) % ids.length
			const id = ids[ next ]
			this.selected_id( id )
			this.selected_scroll_to( id )
		}

		@ $mol_action
		selected_scroll_to( id: string ) {
			new this.$.$mol_after_frame( ()=> {
				this.selected_view( id )?.dom_node().scrollIntoView({
					block: 'nearest',
				})
			} )
		}

		selected_view( id: string ) {
			if( id.startsWith( 'application:' ) ) return this.Application_add( id.slice( 12 ) )
			if( id.startsWith( 'item:' ) ) return this.Item_add( id.slice( 5 ) )
			if( id.startsWith( 'custom:' ) ) {
				const ref = this.custom_refs_filtered().find( ref => this.custom_select_id( ref ) === id )
				if( ref ) return this.Custom_add( ref )
			}
			return null
		}

		@ $mol_mem
		search_focus() {
			if( !this.contextmenu_showed() ) return
			this.$.$mol_wait_timeout( 0 )
			this.Search().focused( true )
		}

		@ $mol_action
		search_keydown( event?: KeyboardEvent ) {
			if( !event ) return null

			switch( event.key ) {
				case 'ArrowDown':
					event.preventDefault()
					this.select_shift( 1 )
					break
				case 'ArrowUp':
					event.preventDefault()
					this.select_shift( -1 )
					break
				case 'Escape':
					event.preventDefault()
					this.contextmenu_showed( false )
					break
			}

			return event
		}

		@ $mol_action
		submit( event?: Event ) {
			if( !event ) return null
			const id = this.selected_select_id() || this.select_ids()[0]
			if( !id ) return
			if( id.startsWith( 'application:' ) ) return this.application_add( id.slice( 12 ), event )

			if( id.startsWith( 'item:' ) ) return this.widget_add( id.slice( 5 ), event )
			if( id.startsWith( 'custom:' ) ) {
				const ref = this.custom_refs_filtered().find( ref => this.custom_select_id( ref ) === id )
				if( ref ) return this.custom_add( ref, event )
			}
		}

		item_title( id: any ): string {
			return $shm_hitalama_map_widget_presets_def( id )?.title
				?? $shm_hitalama_map_widget_def( id )?.title
				?? id
		}

		@ $mol_mem_key
		item_icon( id: any ): $mol_icon_square_outline {
			const Icon = $shm_hitalama_map_widget_def( id )?.icon ?? this.preset_icon( id )
			if( !Icon ) return super.item_icon( id )
			return new Icon() as $mol_icon_square_outline
		}

		preset_icon( id: any ): null | typeof $mol_icon {
			switch( $shm_hitalama_map_widget_presets_def( id )?.icon ) {
				case 'code_braces': return $mol_icon_code_braces
				case 'map': return $mol_icon_image
				case 'chart_bar': return $mol_icon_chart_bar
				case 'key': return $mol_icon_key
				case 'send': return $mol_icon_send
				case 'form_dropdown': return $mol_icon_form_dropdown
				case 'form_textbox': return $mol_icon_form_textbox
				case 'tune_variant': return $mol_icon_tune_variant
				case 'calendar': return $mol_icon_calendar
				case 'gesture_tap_button': return $mol_icon_gesture_tap_button
				default: return null
			}
		}

		id( id: any ): string {
			return id
		}

	}

	type ArrayToObject<T extends readonly string[]> = {
		[K in T[number]]: string;
	  };

}
